import StrictObj from './strict-obj'
import { isUndefined } from 'lodash-es'

/*
  parseUrl('http://stage.gleam.io:80/g/lAf5U?h=f#anchor')

  {
    href: "http://stage.gleam.io:8080/g/lAf5U?h=f#anchor"
    host: "stage.gleam.io:8080"
    port: "8080"
    hash: "#anchor"
    search: "?h=f"
    origin: "http://stage.gleam.io:8080"
    protocol: "http:"
    hostname: "stage.gleam.io"
    pathname: "/g/lAf5U"
  }
*/

export default function parseUrl(url) {
  const aElm = document.createElement('a')
  aElm.href = url
  const parse = StrictObj({
    href: aElm.href,
    host: aElm.host,
    port: aElm.port,
    hash: aElm.hash,
    search: aElm.search,
    origin: aElm.origin,
    hostname: aElm.hostname,
    pathname: aElm.pathname,
    protocol: aElm.protocol
  })

  if (isUndefined(parse.origin)) {
    const canSkipPort = false
      || (parse.protocol === 'http:' && parse.port === '80')
      || (parse.protocol === 'https:' && parse.port === '443')
    parse.origin = parse.protocol + '//' + parse.hostname + (canSkipPort ? '' : parse.port)
  }

  aElm.href = ''
  return parse
}
